import { evaluate } from '../../controllers/base/evaluate.js';
import { isTooltipConfig } from './tooltip-config.js';

/**
 * 获得含shortcut的tooltip
 */
function getTooltipWithShortCut(item) {
    var _a, _b;
    if (!(item.tooltip)) {
        return undefined;
    }
    // 若有自定义tooltip不展示快捷键
    if (isTooltipConfig(item.tooltip)) {
        return undefined;
    }
    // 这里是不是非常不好 android pad怎么办
    const isMac = !!(/(Mac)/i.exec(window.navigator.platform));
    const isPad = !!(/(iPad)/i.exec(window.navigator.platform));
    if (isPad) {
        return undefined;
    }
    const tooltip = evaluate(item.tooltip, '');
    if (isMac && ((_a = item.shortcut) === null || _a === void 0 ? void 0 : _a.mac)) {
        const shortcutContent = item.shortcut.mac;
        // 如果 tooltip 是数组形式, 并且含有shortcut, 则拼接在 数组第一个元素内, 且只拼接一次
        if (Array.isArray(tooltip)) {
            const tooltipArray = [...tooltip];
            tooltipArray[0] = `${tooltip[0]} (${shortcutContent})`;
            return tooltipArray;
        }
        return `${tooltip} (${shortcutContent})`;
    }
    if (!isPad && ((_b = item.shortcut) === null || _b === void 0 ? void 0 : _b.win)) {
        const shortcutContent = item.shortcut.win;
        if (Array.isArray(tooltip)) {
            const tooltipArray = [...tooltip];
            tooltipArray[0] = `${tooltip[0]} (${shortcutContent})`;
            return tooltipArray;
        }
        return `${tooltip} (${shortcutContent})`;
    }
    return undefined;
}

export { getTooltipWithShortCut };
//# sourceMappingURL=tooltip-with-shortcut.js.map
